import { publicClient, privateClient } from './client';
import { CyberSource } from './CyberSource';

const customCyberSource = (pub: boolean) => new CyberSource(pub ? publicClient : privateClient);
export default customCyberSource;
